"use client"

import React, { createContext, useContext, useEffect, useState } from "react";

const appContext = createContext();

const AppProvider = ({ children }) => {
    // const [selected, setSelected] = useState(() => {
    //     const storedSelected = window.selected ?? localStorage.getItem('selected');
    //     return storedSelected ? JSON.parse(storedSelected) : { event: "", time: "" };
    // });

    const [isCameraActive, setIsCameraActive] = useState(false);
    const [totalCheckedIn, setTotalCheckedIn] = useState(`0/0`);

    // useEffect(() => {
    //     if (selected) {
    //         localStorage.setItem('selected', JSON.stringify(selected));
    //         window.selected = selected;
    //     }
    // }, [selected]);

    const value = React.useMemo(() => ({
        // selected, setSelected,
        isCameraActive, setIsCameraActive,
        totalCheckedIn, setTotalCheckedIn,
    }), [
        // selected,
        isCameraActive,
        totalCheckedIn,
    ]);

    return (
        <appContext.Provider value={value}>
            {children}
        </appContext.Provider>
    );
};

const useAppContext = () => useContext(appContext);

export { useAppContext, AppProvider };